import React, { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useApi } from '../api'
import { ICargo } from '../interfaces'

interface ImageUploaderProps {
  projectCode: string;
  image?: string;
  onUploaded: (cargo: ICargo) => void
}
export const ImageUploader = ({ projectCode, image, onUploaded }: ImageUploaderProps) => {
  const api = useApi(projectCode)

  const [imgSrc, setImgSrc] = useState<string | null>(null)

  const uploadFile = useCallback((fileOfBlob: Blob) => {
    api.uploadImageFile(projectCode, fileOfBlob, (cargo: ICargo) => {
      onUploaded(cargo)
    })
  }, [api, onUploaded, projectCode])

  const onDrop = useCallback((acceptedFiles: any) => {
    acceptedFiles.forEach((file: any) => {
      const reader = new FileReader()

      reader.onabort = () => console.log('file reading was aborted')
      reader.onerror = () => console.log('file reading has failed')
      reader.onload = () => {
        // Do whatever you want with the file contents
        const binaryStr = reader.result
        if (binaryStr) {
          setImgSrc(binaryStr.toString())
          const img = new Image()
          img.src = binaryStr.toString()
          img.onload = () => {
            const width = 600
            const scaleFactor = width / img.width
            const elem = document.createElement('canvas');
            elem.width = width
            elem.height = img.height * scaleFactor

            const ctx = elem.getContext('2d')
            if (ctx) {
              ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, width, img.height * scaleFactor)
              ctx.canvas.toBlob((blob) => {
                const fileOfBlob: BlobPart = new File([blob as BlobPart], file['name'], {
                  type: 'image/jpeg',
                  lastModified: Date.now()
                });
                uploadFile(fileOfBlob)
              }, 'image/jpeg', 1)
            }
            // img.width and img.height will contain the original dimensions
          }
        }
      }
      reader.readAsDataURL(file)
    })

  }, [uploadFile])
  const { getRootProps, getInputProps } = useDropzone({ onDrop })

  return (
    imgSrc === null ?
      <div className='border border-dashed rounded-lg' {...getRootProps()}>
        <input {...getInputProps()} />
        <p className='whitespace-pre-wrap text-gray-500 m-0'>
          <img className='rounded-lg w-100' src={image ? image : require('../assets/img/placeholder-img.jpeg')} alt='' />
        </p>
      </div>
      :
      <div><img className='rounded-lg mx-auto' src={imgSrc} alt='' /></div>
  )
}